import React from "react";

// Slow editorial marquee strip. Duplicated content for a seamless loop.
export const Marquee = ({ items, testId = "marquee" }) => {
  const content = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#0A0D12] py-6 md:py-8" data-testid={testId}>
      <div className="marquee-track flex whitespace-nowrap will-change-transform">
        {content.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-2xl md:text-4xl font-light text-white/90 px-8">{it}</span>
            <span className="text-[#C8A45A] text-xl md:text-2xl">✦</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-48 bg-gradient-to-r from-[#0A0D12] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-48 bg-gradient-to-l from-[#0A0D12] to-transparent" />
    </div>
  );
};

export default Marquee;
